import React from 'react';

const TitleBarWrapper = props => {
  return (
    props.children
  )
}

export default React.memo(TitleBarWrapper)
